export default {
  group_name_placeholder: 'Set channel name',
  group_purpose_placeholder: 'Set channel purpose',
};
